import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
  Filter,
  SearchInput,
  SimpleList,
} from 'react-admin';
import { useMediaQuery } from '@material-ui/core';

const PurchaseFilter = (props: any) => (
  <Filter {...props} variant="outlined">
    <SearchInput label="Doc. Serial No" source="poNo~like" alwaysOn />
  </Filter>
);

export const PurchaseList = (props: any) => {
  const propsObj: any = { ...props };
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  if (propsObj.permissions) {
    const resourcename = `/${props.resource}`;
    const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
    if (myPermissions.length > 0) {
      const p = myPermissions[0];
      propsObj.hasList = p.View === 1;
      propsObj.hasShow = p.View === 1;
      propsObj.hasEdit = p.Edit === 1;
      propsObj.hasDelete = p.Delete === 1;
      propsObj.hasCreate = p.Create === 1;
      propsObj.hasExport = p.Export === 1;
    }
  }

  return (
    <React.Fragment>
      <List
        {...propsObj}
        // exporter={propsObj.hasExport}
        exporter={false}
        bulkActionButtons={false}
        title="Purchase"
        sort={{ field: 'createdDate', order: 'DESC' }}
        filters={<PurchaseFilter />}
      >
        {isSmall ? (
          <SimpleList
            primaryText={(record: any) => record.poNo || ''}
            secondaryText={(record: any) =>
              record.poDate ? `Date: ${new Date(record.poDate).toLocaleDateString()}` : ''
            }
            tertiaryText={(record: any) =>
              record.createdDate ? `Created: ${new Date(record.createdDate).toLocaleDateString()}` : ''
            }
            linkType={propsObj.hasEdit ? 'edit' : 'show'}
          />
        ) : (
          <Datagrid rowClick={propsObj.hasEdit ? 'edit' : undefined}>
            {propsObj.hasEdit && <EditButton />}
            
            <TextField source="poNo" label="Doc. Serial No." />
            <DateField source="poDate" label="Doc. Date" locales="fr-FR" />
            <DateField source="createdDate" label="Created Date" locales="fr-FR" />
          </Datagrid>
        )}
      </List>
    </React.Fragment>
  );
};

